/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Deleteconfirmdesc2Inputs */

const zh_sidebar_deleteconfirmdesc2 = /** @type {(inputs: Sidebar_Deleteconfirmdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除后将无法恢复该对话及其所有消息，确定要删除吗？`)
};

const en_sidebar_deleteconfirmdesc2 = /** @type {(inputs: Sidebar_Deleteconfirmdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This conversation and all its messages will be permanently deleted. Are you sure?`)
};

const es_sidebar_deleteconfirmdesc2 = /** @type {(inputs: Sidebar_Deleteconfirmdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conversación y todos sus mensajes se eliminarán permanentemente. ¿Estás seguro?`)
};

/**
* | output |
* | --- |
* | "This conversation and all its messages will be permanently deleted. Are you sure?" |
*
* @param {Sidebar_Deleteconfirmdesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_deleteconfirmdesc2 = /** @type {((inputs?: Sidebar_Deleteconfirmdesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Deleteconfirmdesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_deleteconfirmdesc2(inputs)
	if (locale === "en") return en_sidebar_deleteconfirmdesc2(inputs)
	return es_sidebar_deleteconfirmdesc2(inputs)
});
export { sidebar_deleteconfirmdesc2 as "sidebar_deleteConfirmDesc" }